import * as $ from "jquery";

class RoadmapContainer {
  domRoot: HTMLElement;
  params: any;
  parentCont: any;
  ships: any;
  results: any;
  searchResults: any;
  newShippedContainer: any;
  newComingSoonContainer: any;
  searchForm: any;
  searchInput: any;
  mainEl: HTMLElement;
  isMainComponent: any;
  jumpToContent: any;
  hideSearch: any;
  contentJumpDistance: any;
  sortItems: any;
  fullPageContent: any;
  labels: any;
  searchTerm: string;
  history: number;
  fullPage?: HTMLElement;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.parentCont = domRoot.querySelector(".roadmap-container");
    this.ships = domRoot.querySelector(".ships-area");
    this.results = domRoot.querySelector(".results");
    this.searchResults = domRoot.querySelector(".search-results");
    this.newShippedContainer = domRoot.querySelector(".new-shipped");
    this.newComingSoonContainer = domRoot.querySelector(".new-comingsoon");
    this.searchForm = domRoot.querySelector(".search-form");
    this.searchInput = domRoot.querySelector(".search-input")
    this.mainEl = document.querySelector('main') as HTMLElement;
    this.isMainComponent = params.isMainComponent;
    this.jumpToContent = params.jumpToContent;
    this.hideSearch = params.hideSearch;
    this.contentJumpDistance = params.contentJumpDistance;
    this.sortItems = params.sortingItems;
    this.fullPageContent = params.fullPageContent;
    this.labels = params.labels;
    this.searchTerm = '';
    this.history = 0;
    this.init();
  }

  init() {
    document.body.classList.add('roadmap-prep');

    if (document.getElementById('roadmap-component-preview') == null) {
      this.mainEl.insertAdjacentHTML('afterend', `<div id="roadmap-component-preview" class="preview-area"></div>`);
    }
    this.fullPage = document.getElementById('roadmap-component-preview');

    this.searchResults.addEventListener('click', (e) => {
      if (e.target.classList.contains("back-to-results")) {
        this.searchInput.value = "";
        this.renderSearches("");
      }
    });

    this.fullPage.addEventListener('click', (e) => {
      if (e.target.classList.contains("back-to-results")) {
        this.mainEl.setAttribute('style', 'position: relative; left: 0;');
        this.fullPage.setAttribute('style', 'position: absolute; left: 100%;');
      }
    });

    this.results.addEventListener('click', (e) => {
      if (e.target.classList.contains("roadmap-link")) {
        e.preventDefault();
        var parentItem = e.target.parentNode.parentNode;
        var isShowing = parentItem.classList.contains('showing');
        var allItems = this.domRoot.querySelectorAll('.component--roadmap-item');
        for (var i = 0; i < allItems.length; i++) {
          allItems[i].classList.remove('showing');
        }
        parentItem.classList.toggle('showing', !isShowing);

        if (this.jumpToContent) {
          var scrollToItem = $(parentItem);
          $('html, body').animate({
            scrollTop: scrollToItem.offset().top - Number(this.contentJumpDistance.replace(/[^0-9]/g, ''))
          }, 500);
        }
      }
      if (e.target.classList.contains("standalone-link")) {
        var hash = e.target.id.replace('plan-', '');
        var matchingPage = this.fullPageContent[hash];
        if (matchingPage && matchingPage.pageContent) {
          this.renderFullPage(hash);
        }
      }
    });

    if (!this.hideSearch) {
      this.searchInput.addEventListener('keyup', (e) => {
        this.renderSearches(e.target.value);
      });
    }
  }

  renderSearches(hashParam) {
    var searchString = hashParam.trim();
    var hash = searchString;
    var itemsHTML = this.getResultsHeaderHTML();
    if (searchString == "") {
      this.searchInput.value = searchString;
      this.searchResults.style.display = 'none';
      this.results.style.display = 'block';
    } else {
      this.searchResults.style.display = 'block';
      this.results.style.display = 'none';
    }
    var numItems = 0;
    for (var s = 0; s < this.sortItems.length; s++) {
      var itemID = this.sortItems[s].id;
      var item = this.fullPageContent[itemID];
      var searchDescription = item.textOnlyLower.toString();
      if (searchDescription.indexOf(searchString) > -1) {
        var foundIndex = searchDescription.indexOf(searchString);
        numItems++;
        itemsHTML += `<div class="component component--roadmap-item result-${itemID}">
          <div class="roadmap-inner">
            <a href="#result-${itemID}" class="roadmap-link"><h3 class="roadmap-title">
            ${item.title}
            </h3>
            <p class="search-contents">
              ${this.getSearchSnippetHTML(hash, foundIndex, item.textOnly)}
            </p></a>
          </div>
        </div>
        `;
      }
    }
    if (numItems === 0) {
      itemsHTML += `<h3>${this.labels.noResults}</h3>`;
    }
    itemsHTML += `</div>`;
    this.searchResults.innerHTML = itemsHTML;
  }

  renderFullPage(hash) {
    var item = this.fullPageContent[hash];
    var headerHTML = `<div class="container"><div class="row">
    <div>${this.getResultsHeaderHTML()}
      <h3>${item.title} ${this.getLozengeHTML(item.lozengeColor, item.lozengeLabel)}</h3></div>`;
    var previewFooter = `<a class="tweet-link" target="_blank" href="https://twitter.com/intent/tweet?text=${item.title}&url=${encodeURIComponent(window.location)}&via=Atlassian">
      ${this.getTweetIcon()}
      Tweet
    </a></div></div>`;

    this.fullPage.innerHTML = headerHTML + item.pageContent + previewFooter;
    this.fullPage.setAttribute('style', 'position: relative; left: 0;');
    this.mainEl.setAttribute('style', 'position: absolute; left: -100%;');
    $('html, body').animate({
      scrollTop: $(this.fullPage).offset().top
    }, 250);
  }

  getLozengeHTML(color = "purple", text) {
    if (text) {
      return `<span class="lozenge ${color}">${text}</span>`;
    }
    return '';
  }

  getShippedDateHTML(isShipped, shippedDate, customLabel) {
    if (isShipped && !customLabel && customLabel.length < 1) {
      return `<span class="date eyebrows">${shippedDate.match(/^(?:\S*\s*){3}/)}</span>`;
    } else if (customLabel && customLabel.length > 1) {
      return `<span class="custom-label eyebrows date">${customLabel}</span>`;
    }
    return "";
  }

  getSearchSnippetHTML(hash, index, description) {
    if (index > -1) {
      var properCase = description.substr(index, hash.length);
      var wordsnip1 = description.substr(0, index).split(' ');
      wordsnip1 = wordsnip1.length ? wordsnip1.slice(-10) : [''];
      wordsnip1 = wordsnip1.join(' ');
      var wordsnip2 = description.substr((index + hash.length), (index + hash.length + 120)).split(' ');
      wordsnip2 = wordsnip2.length ? wordsnip2.slice(0, 10) : [''];
      wordsnip2 = wordsnip2.join(' ');
      return `...${wordsnip1}<span class="highlight">${properCase}</span>${wordsnip2}...`;
    }
    return '';
  }

  getResultsHeaderHTML() {
    return `<a href="javascript:void(0);" class="link-arrow back-to-results">
      <svg class="link-arrow-image" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M10.297,4.2915 L3.298,11.2905 C3.296,11.2915 3.294,11.2925 3.291,11.2945 C3.097,11.4885 3,11.7455 3,12.0025 C3,12.2595 3.097,12.5165 3.291,12.7115 C3.294,12.7125 3.297,12.7135 3.299,12.7155 L10.294,19.7105 C10.683,20.1005 11.319,20.1005 11.708,19.7105 C12.097,19.3225 12.097,18.6855 11.708,18.2965 L6.414,13.0025 L20,13.0025 C20.55,13.0025 21,12.5525 21,12.0025 C21,11.4535 20.55,11.0035 20,11.0035 L6.414,11.0035 L11.711,5.7055 C12.1,5.3165 12.1,4.6805 11.711,4.2915 C11.516,4.0975 11.26,4.0005 11.003,4.0005 C10.747,4.0005 10.49,4.0975 10.297,4.2915 Z"></path></svg>
      ${this.labels.allFeatures}
    </a>`;
  }

  getTweetIcon() {
    return `<svg width="48" height="48" version="1.1" viewBox="0 0 48 48" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M23.85195, 19.84437c-1.7454-4.8355,6.1102-9.4326, 9.347-5.0194c0,0,1.2547-0.0451, 3.5444-1.278 c0,0-0.546, 1.7435-2.3073, 2.8973c0,0,1.3386-0.0087, 2.959-0.7308c0,0-1.0215, 1.6556-2.6068, 2.7653 c0,0-0.0352, 2.4835-0.4051, 4.0335c-0.3698,1.55-1.6028, 5.8653-5.3016,8.8948c-3.6989,3.0295-8.2079,3.6989-10.7619, 3.5227     c-2.554-0.1761-5.6892-1.1449-7.7147-2.3954c0, 0,4.6323, 0.4932,8.0494-2.325c0, 0-3.4523,0.1585-5.0903-3.8221 c0,0,1.1801,0.2113, 2.4482-0.141c0, 0-4.3505-0.7926-4.4033-5.4778c0, 0, 1.4267, 0.7046, 2.4835, 0.6341 c0, 0-4.1568-3.1704-1.6205-7.2744C12.47195, 14.12817, 16.63195, 19.64227, 23.85195, 19.84437z" style="fill:#4AA0EC;"/></svg>`;
  }
}
export default RoadmapContainer;